import React from 'react';

import * as styles from '../icons.css';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={60}
    viewBox="0 0 70 82"
    xmlSpace="preserve"
    focusable="false"
    fill="currentColor"
    className={styles.root}
  >
    <g
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
    >
      <path
        fill="none"
        className={styles.stroke}
        d="M44.547 14.463c0 7.296-5.91 13.211-13.208 13.211-7.293 0-13.208-5.915-13.208-13.211 0-7.295 5.915-13.207 13.208-13.207 7.298 0 13.208 5.912 13.208 13.207z"
      />
      <path
        className={[styles.stroke, styles.fill].join(' ')}
        d="M61.283 60.373c-.02-.139-.041-.277-.064-.416a30.452 30.452 0 0 0-.404-1.994c-.029-.119-.062-.238-.094-.359a29.75 29.75 0 0 0-.525-1.854c-.021-.066-.039-.131-.061-.193a30.936 30.936 0 0 0-.701-1.9l-.164-.396a29.935 29.935 0 0 0-.83-1.811c-.043-.086-.09-.168-.133-.254a27.793 27.793 0 0 0-.898-1.623l-.158-.273a30.042 30.042 0 0 0-1.326-1.993 30.955 30.955 0 0 0-1.211-1.578c-.035-.043-.07-.082-.107-.125a30.32 30.32 0 0 0-1.254-1.406 29.659 29.659 0 0 0-1.973-1.906 31.182 31.182 0 0 0-1.482-1.236l-.078-.063a31 31 0 0 0-1.623-1.159c-.119-.081-.24-.162-.359-.24a32.543 32.543 0 0 0-1.67-1.014c-.107-.06-.217-.115-.324-.174a29.937 29.937 0 0 0-1.637-.834c-.082-.038-.16-.08-.244-.117a30.498 30.498 0 0 0-2.258-.922 28.838 28.838 0 0 0-1.978-.647l.002.538-7.974 8.499-7.962-8.499-.387-.661c-.064.018-.13.034-.195.053-.66.184-1.312.385-1.952.611-.095.033-.187.07-.279.104-.603.218-1.197.456-1.783.713-.083.037-.17.071-.253.107a29.91 29.91 0 0 0-1.805.89l-.38.205c-.584.321-1.159.658-1.72 1.017-.079.05-.153.104-.23.154-.523.341-1.035.698-1.535 1.071-.087.064-.175.125-.26.19a29.596 29.596 0 0 0-1.855 1.537c-.495.441-.98.898-1.445 1.373-.054.055-.105.111-.158.168-.437.449-.856.918-1.265 1.395-.076.088-.153.176-.228.266a29.274 29.274 0 0 0-1.214 1.559c-.083.113-.165.23-.246.344a29.494 29.494 0 0 0-1.115 1.682l-.088.148a30.208 30.208 0 0 0-.944 1.688c-.057.109-.115.217-.171.328-.3.592-.581 1.197-.842 1.812-.054.127-.104.258-.158.385-.26.637-.507 1.281-.723 1.939-.011.029-.019.059-.028.09a29.56 29.56 0 0 0-.561 1.953c-.031.127-.065.252-.098.379a30.412 30.412 0 0 0-.409 2.014c-.026.134-.046.269-.066.403a30.194 30.194 0 0 0-.265 2.145h60.407a28.214 28.214 0 0 0-.259-2.113z"
      />
    </g>
    <path
      fill="none"
      className={styles.stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M25.802 19.229s5.083 7.405 11.436 0m.2 43.196h23.928c-1.299-15.512-14.271-27.699-30.117-27.699-15.842 0-28.819 12.187-30.113 27.699h36.302z"
    />
    <path
      fill="none"
      className={styles.stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m59.273 16.594 3.073 6.426 6.519-.098-4.769 5.304 1.629 6.919-6.194-3.48-5.929 3.689 1.47-6.899-5.34-5.206 6.815-.128z"
    />
    <ellipse className={styles.shadow} cx={31.52} cy={78.744} rx={17} ry={3} />
  </svg>
);
